@if (loading()) {
  <app-loading />
} @else {
  @if (showProgressDashboard()) {
    <app-progress-dashboard
      [attributesByEvaluationCriteria]="dashboardAttributesByEvaluationCriteriaMap()"
      [evaluationCriteria]="dashboardEvaluationCriteria()"
      [evaluationSubCriteria]="dashboardEvaluationSubCriteria()"
      [phase]="phaseType()"
      [pieChartLabel]="pieChartLabel()"
    />
  }
  <div data-testid="provider-questionnaire-attributes-page">
    @if (ecTabs().length > 0) {
      @if (showHeader()) {
        <app-questionnaire-header
          deadlineTranslationKey="provider.tender.confirmation.deadline"
          [deadlineValue]="tenderDetails()!.submissionDate"
          finishButtonTranslationKey="provider.questionnaire.finishButton"
          [canFinish]="canFinishQuestionnaire()"
          [isFinishing]="isFinishing()"
          (finishClick)="onFinishQuestionnaireClick()"
        >
          @if (showsTemplateFill()) {
            <p-button
              [label]="'provider.questionnaire.templateFill.button' | transloco"
              icon="pi pi-file-import"
              severity="secondary"
              [outlined]="true"
              [loading]="loadingTemplateFill()"
              [disabled]="loadingTemplateFill() || fillingFromTemplate()"
              (onClick)="onFillFromTemplateClick()"
              data-testid="template-fill-button"
            />
          }
        </app-questionnaire-header>
        <app-template-fill-dialog
          [(visible)]="templateFillDialogVisible"
          [summary]="templateFillSummary()"
          [filling]="fillingFromTemplate()"
          (confirmed)="onTemplateFillConfirmed($event)"
        />
      }

      <ng-container
        *ngTemplateOutlet="
          showTemplateTitle() ? cardWrapper : tabsOnly;
          context: {$implicit: tabsContent}
        "
      />

      <ng-template #cardWrapper let-content>
        <div class="card">
          <div class="flex justify-between items-start gap-6 flex-wrap mb-6">
            <div>
              <h3 class="text-xl font-semibold">{{ templateTitleKey() + '.title' | transloco }}</h3>
              <p class="text-sm mt-1">{{ templateTitleKey() + '.description' | transloco }}</p>
            </div>
            @if (showsSuggestionToolbar()) {
              <div class="flex flex-wrap items-center gap-3" data-testid="suggestion-toolbar">
                <app-options-select
                  [options]="suggestionFilterOptions"
                  [value]="suggestionStore.filter()"
                  (valueChange)="onSuggestionFilterChange($event)"
                  placeholder="provider.templates.suggestions.filter.label"
                  testId="suggestion-filter"
                  styleClass="w-72"
                />
                @if (showsBulkAccept()) {
                  <p-button
                    [label]="
                      'provider.templates.suggestions.bulk.button'
                        | transloco: {count: bulkAcceptCount()}
                    "
                    icon="pi pi-check-square"
                    severity="secondary"
                    [outlined]="true"
                    [disabled]="bulkAccepting()"
                    [loading]="bulkAccepting()"
                    (onClick)="onBulkAccept()"
                    data-testid="suggestion-bulk-accept"
                  />
                }
              </div>
            }
          </div>
          <ng-container *ngTemplateOutlet="content" />
        </div>
      </ng-template>

      <ng-template #tabsOnly let-content>
        <ng-container *ngTemplateOutlet="content" />
      </ng-template>

      <ng-template #tabsContent>
        <p-tabs
          appTabsUnsavedReveal
          [value]="activeECTabIndex()"
          (valueChange)="onECTabChange(+$event!)"
          class="questionnaire-tabs ec-tabs"
          [class.hidden]="phaseType() === TenderPhaseType.RFI"
          scrollable
        >
          @if (phaseType() !== TenderPhaseType.RFI) {
            <p-tablist>
              @for (ecTab of ecTabs(); track ecTab.id; let i = $index) {
                <p-tab
                  [value]="i"
                  [appTabStatus]="ecTabCompletionStatus()[i]"
                  [appTabStatusUnsaved]="ecTabsUnsaved()[i]"
                >
                  <span>{{ ecTab.translations | translateDirectus }}</span>
                </p-tab>
              }
            </p-tablist>
          }

          <p-tabpanels
            [class.mt-6]="phaseType() !== TenderPhaseType.RFI"
            [class.mt-0]="phaseType() === TenderPhaseType.RFI"
          >
            @for (ecTab of ecTabs(); track ecTab.id; let ecIndex = $index) {
              <p-tabpanel [value]="ecIndex">
                @if (activeECTabIndex() === ecIndex && isEC3(ecTab.ecNumber) && ecTab.moduleTabs) {
                  <app-questionnaire-ec3-tabs
                    [moduleTabs]="ecTab.moduleTabs"
                    [activeModuleTabIndex]="activeModuleTabIndex()"
                    [activeModuleScTabIndex]="activeModuleScTabIndex()"
                    [moduleTabCompletionStatus]="currentModuleTabCompletionStatus()"
                    [moduleTabsUnsaved]="currentModuleTabsUnsaved()"
                    [scTabCompletionStatus]="currentScTabCompletionStatus()"
                    [scTabsUnsaved]="currentScTabsUnsaved()"
                    [badgeListItems]="currentTabBadgeListItems()"
                    [canSave]="!readonly() && currentTabCanSave()"
                    [isSaving]="currentTabIsSaving()"
                    [disabled]="readonly()"
                    [showImportanceScore]="mode() !== QuestionnaireMode.TEMPLATE"
                    (moduleTabChange)="onModuleTabChange($event)"
                    (moduleScTabChange)="onModuleScTabChange($event)"
                    (attributeValueChange)="onAttributeChange($event)"
                    (saveClick)="saveCurrentTabAttributes()"
                  />
                } @else if (activeECTabIndex() === ecIndex) {
                  <app-questionnaire-standard-tabs
                    [subcriteriaTabs]="ecTab.subcriteriaTabs"
                    [activeScTabIndex]="activeScTabIndex()"
                    [scTabCompletionStatus]="currentScTabCompletionStatus()"
                    [scTabsUnsaved]="currentScTabsUnsaved()"
                    [badgeListItems]="currentTabBadgeListItems()"
                    [canSave]="!readonly() && currentTabCanSave()"
                    [isSaving]="currentTabIsSaving()"
                    [disabled]="readonly()"
                    [showImportanceScore]="mode() !== QuestionnaireMode.TEMPLATE"
                    [toolId]="projectReferencesToolId()"
                    [projectReferenceScores]="projectReferenceScores()"
                    [projectReferencesReadOnly]="showTenderProjectReferences()"
                    (scTabChange)="onScTabChange($event)"
                    (projectReferencesSavedCountChange)="
                      onProjectReferencesSavedCountChange($event)
                    "
                    (projectReferencesUnsavedChange)="onProjectReferencesUnsavedChange($event)"
                    (attributeValueChange)="onAttributeChange($event)"
                    (saveClick)="saveCurrentTabAttributes()"
                  />
                }
              </p-tabpanel>
            }
          </p-tabpanels>
        </p-tabs>
      </ng-template>
    } @else {
      @if (readonly()) {
        <div class="card">
          <app-no-data
            icon="pi pi-info-circle"
            label="shared.subcriteriaAttributes.noDataTitle"
            description="shared.subcriteriaAttributes.noDataMessage"
          />
        </div>
      } @else {
        <app-no-data />
      }
    }
  </div>
}
